import { render, staticRenderFns } from "./SrNavigationBar.vue?vue&type=template&id=4ffe475e"
import script from "./SrNavigationBar.vue?vue&type=script&lang=js"
export * from "./SrNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports